"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var FileTypePdf = function FileTypePdf(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    fill: "none"
  }, props), (0, _preact.h)("path", {
    fill: "#d32f2f",
    fillRule: "evenodd",
    d: "M8 0C5.796875 0 4 1.796875 4 4v7H1c-.550781 0-1 .449219-1 1v6c0 .550781.449219 1 1 1h3v3c0 2.203125 1.796875 4 4 4h12c2.203125 0 4-1.796875 4-4V8c0-1.0625-.972656-2.070312-2.71875-3.78125-.242187-.238281-.503906-.503906-.75-.75-.246094-.246094-.511719-.476562-.75-.71875C18.070313 1.003906 17.0625 0 16 0H8zm0 2h7.28125c.722656.183594.71875 1.050781.71875 1.9375V7c0 .550781.449219 1 1 1h3c.996094 0 2 .003906 2 1v13c0 1.105469-.894531 2-2 2H8c-1.105469 0-2-.894531-2-2v-3h12c.550781 0 1-.449219 1-1v-6c0-.550781-.449219-1-1-1H6V4c0-1.105469.894531-2 2-2z"
  }), (0, _preact.h)("path", {
    fill: "#fff",
    d: "M3.80859 15.996v2.004H2.63672v-5.6875h2.21875c.42709 0 .80273.0781 1.12695.2344.32422.1562.57357.3782.74805.666.17448.2877.26172.6152.26172.9824 0 .5573-.19076.9967-.57227 1.3183-.38151.3216-.90951.4824-1.58398.4824H3.80859zm0-.9492h1.04687c.30991 0 .54624-.0729.70899-.2188.16276-.1458.24414-.3541.24414-.625 0-.2786-.08203-.5039-.24609-.6758-.16406-.1718-.39063-.2604-.67969-.2656H3.80859v1.7852zM7.79688 18v-5.6875h1.75c.50001 0 .94732.1126 1.34182.3379.3945.2252.7025.5456.9238.9609.2214.4154.332.8874.332 1.416v.2617c0 .5287-.1087.9987-.3262 1.4102-.2174.4114-.5241.7304-.9199.957-.3958.2265-.84241.3411-1.33984.3437H7.79688zm1.17187-4.7383v3.7969h.56641c.45833 0 .80859-.1497 1.05079-.4492.24218-.2995.36588-.7279.37109-1.2852v-.3008c0-.5781-.11979-1.0163-.35938-1.3145-.24023-.2981-.54752-.4473-1.00781-.4473h-.62109zm7.44925 3.4141h-2.25v2.3242h-1.17187v-5.6875h3.70312v.9492h-2.53125v1.4688h2.25v.9453z"
  }));
};

var _default = FileTypePdf;
exports.default = _default;